import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/site';
const { FiArrowUpRight, FiMapPin, FiHeart, FiMaximize, FiGrid } = FiIcons;
function PropertyCard({ property, index }) {
  const [fav, setFav] = useState(false);
  return (
    <article className="property-card">
      <div className="property-image-wrap">
        <img src={property.image} alt={`${property.name} interior`} />
        <span className="property-tag">{property.tag}</span>
        <button className={fav ? 'property-fav active' : 'property-fav'} onClick={(e) => { e.stopPropagation(); setFav(!fav); }} aria-label="Save property">
          <SafeIcon icon={FiHeart} />
        </button>
      </div>
      <div className="property-details">
        <div className="property-location"><SafeIcon icon={FiMapPin} /> {property.location}</div>
        <h3>{property.name}</h3>
        <div className="property-meta">
          <span><SafeIcon icon={FiGrid} /> <b>{property.beds}</b> Beds</span>
          <span><SafeIcon icon={FiGrid} /> <b>{property.baths}</b> Baths</span>
          <span><SafeIcon icon={FiMaximize} /> <b>{property.area}</b> sq ft</span>
        </div>
        <div className="property-bottom">
          <div>
            <strong>{property.price}</strong>
            <small>{property.pricePerSqft}</small>
          </div>
          <a className="round-arrow" href={waLink(`Hello, I'm interested in "${property.name}" at ${property.location}.`)} target="_blank" rel="noopener noreferrer" aria-label={`Enquire about ${property.name}`}>
            <SafeIcon icon={FiArrowUpRight} />
          </a>
        </div>
      </div>
    </article>
  );
}
export default PropertyCard;
